<template>
  <model-table
    ref="modelTable"
    :collection="payments"
    :columns="[
      { field: 'id' },
      { field: 'type', component: OrderItemTypeCell },
      { name: 'Subtype', field: payment => (payment.type !== 'custom' && payment.subtype ? { label: $_.startCase(payment.subtype), square: true } : null), component: 'chip' },
      { field: 'state', component: PaymentStateCell },
      { name: 'createdAt', field: row => row.createdAt.i18n('timestamp'), component: 'date-time' },
      { name: 'paidAt', field: row => row.paidAt ? row.paidAt.i18n('timestamp') : null, component: 'date-time' },
      { field: 'amount', component: 'money' },
      { field: 'stripeFee', component: 'money', hide: !showFees },
      { field: 'indyFee', component: 'money', hide: !showFees },
      { name: 'disputedFeeTotal', field: payment => payment.state === 'disputed' || payment.state === 'lost_dispute' ? payment.amount + payment.disputeFee : null, component: 'money', hide: !showFees },
      { field: 'order', component: 'model' },
      { field: 'registerStation', component: 'model' },
      { name: 'actions', align: 'right' }
    ]"
    :sort-by="sortBy"
    :descending="descending"

    :show-add="false"
    :show-edit="false"

    :edit-on-row-click="false"
    @row-clicked="row => handleRowClick(row)"
  >
    <payment-form />

    <dispute-dialog
      ref="disputeDialog"
    />
  </model-table>
</template>

<script>

import ModelTable from 'src/modules/admin/components/ModelTable'
import DisputeDialog from 'src/modules/admin/dispute/DisputeDialog'
import OrderItemTypeCell from 'src/modules/admin/order/components/OrderItemTypeCell'
import PaymentStateCell from 'src/modules/admin/payment/components/PaymentStateCell'
import PaymentForm from 'src/modules/admin/payment/PaymentForm'

export default {
  name: 'PaymentTable',
  components: {
    ModelTable,
    PaymentForm,
    DisputeDialog
  },
  props: {
    transferId: {
      type: Number,
      required: false,
      default: null
    },
    sortBy: {
      type: String,
      required: false,
      default: 'id'
    },
    descending: {
      type: Boolean,
      required: false,
      default: true
    },
    showFees: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  created () {
    _.extend(this, {
      OrderItemTypeCell,
      PaymentStateCell
    })
  },
  methods: {
    handleRowClick (payment) {
      if (payment.state === 'disputed') {
        this.$refs.disputeDialog.show(payment)
      } else {
        this.$refs.modelTable.edit(payment)
      }
    }
  },
  models: {
    payments: {
      order: 'default',
      registerStation: 'default',
      variables () {
        return {
          transferId: this.transferId,
          noCount: true
        }
      }
    }
  }
}
</script>
